import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const getIntegrationKey = async (domain: string, integration: ConsentIntegrationOptions): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/integration-key/${integration}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}